import React from "react";
import { PromoterDetails } from "../../components/PromoterDetails";

const PromoterDetailsPage = () => {
  return <PromoterDetails />;
};

export default PromoterDetailsPage;
